import { CommonModule } from '@angular/common'
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzInputNumberModule } from 'ng-zorro-antd/input-number'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { OnboardingProgressState } from '../../gql/generated'
import { MoleculeModule } from '../../molecule/molecule.module'
import { AuthenticationService } from '../../service/authentication.service'
import { CustomerService } from '../../service/customer.service'
import { OnboardingService } from '../../service/onboarding.service'
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number'
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.less',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MoleculeModule,
    NzInputNumberModule,
    NzButtonModule,
    NzIconModule,
  ],
})
export class VerifyComponent implements OnInit {
  token = ''
  customerId = ''

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private customerService: CustomerService,
    private onboardingService: OnboardingService,
    private nzNotificationService: NzNotificationService
  ) {}

  @ViewChildren('codeInput') codeInputs!: QueryList<NzInputNumberComponent>

  ngOnInit(): void {
    this.customerService.getActiveCustomer().subscribe((response) => {
      const activeCustomer = response?.data?.activeCustomer
      if (!activeCustomer) {
        this.router.navigate(['/login'])
        return
      }

      this.customerId = activeCustomer?.id as string

      this.onboardingService
        .getOnboarding(this.customerId)
        .subscribe((response) => {
          if (
            response?.data?.getOnboarding?.state ===
            OnboardingProgressState.SMS_VERIFICATION
          ) {
            this.onboardingService
              .generateOtp(this.customerId)
              .subscribe(() => {
                this.nzNotificationService.success('Send Verification Code','We’ve sent you a verification code to your phone number.')
              })
          } else {
            this.router.navigate(['/login'])
          }
        })
    })
  }

  resendCode() {
    this.onboardingService.generateOtp(this.customerId).subscribe(() => {
      this.nzNotificationService.success(
        'Send Verification Code',
        'We’ve sent you a verification code to your phone number.'
      )
    })
  }

  submitForm(): void {
    this.onboardingService
      .verifyOtp({
        customerId: this.customerId,
        otp: this.codeArray.join(''),
      })
      .subscribe((response) => {
        if (response?.data?.verifyOtp) {
          this.nzNotificationService.success('Verification Success','Your account has been verified.')
          this.onboardingService.getOnboarding(this.customerId).subscribe((onboardingResponse) => {
            const onboarding = onboardingResponse?.data?.getOnboarding
            const resolveUrl = onboarding?.resolveUrl ?? '/home'
            this.router.navigate([resolveUrl])
          })
        } else {
          this.nzNotificationService.error('Verification Failed','The verification code is invalid. Please try again.')
        }
      })
  }

  codeArray: (number | null)[] = [null, null, null, null, null, null]
  currentFocusIndex = 0

  onKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      this.codeArray[index] = null
      if (this.codeArray[index] === null && index > 0) {
        this.currentFocusIndex = index - 1
        this.focusInput(this.currentFocusIndex)
      }
    } else if (event.key >= '0' && event.key <= '9') {
      this.currentFocusIndex = index + 1
      this.codeArray[index] = +event.key
      if (this.codeArray[index] !== null) {
        event.preventDefault()
        this.focusInput(this.currentFocusIndex)
      }
    }

    if (this.codeArray.every((item) => item !== null)) {
      const code = this.codeArray.join('')
      console.log(code)
    }
  }

  focusInput(index: number) {
    if (index >= 0 && index < 6) {
      setTimeout(() => {
        const inputs = this.codeInputs.toArray()
        inputs[index]?.focus()
      })
    }
  }

  goToChangePhone(){
    this.router.navigate(['/change-phone'])
  }
}
